import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaUnionDefinition } from './TypedDefinition'

export const SchemaUnionPlugin = createSchemaPlugin(
  'Schema.Union',
  SchemaUnionDefinition
)
